export function UserAvatar({ avatarData, avatarColor, name, className = '' }: { avatarData?: string; avatarColor: string; name: string; className?: string }) {
  return <span className={`avatar ${className}`} style={{ background: avatarData ? undefined : avatarColor }}>{avatarData ? <img src={avatarData} alt={`${name}头像`} /> : name.slice(0, 1).toUpperCase()}</span>;
}
